module.exports = __webpack_public_path__ + "static/img/about.2d13201.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about.png
// module id = xWQz
// module chunks = 20